import NotificationsContainer from '@rio-cloud/rio-uikit/NotificationsContainer';
import AuthNotificationListener from 'features/auth/AuthNotificationListener';
import { createAuthClient } from 'features/auth/createAuthClient';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { RouterProvider } from 'react-router';
import { router } from 'routes/Router';
import { createAppStore } from 'store/store';

if (import.meta.env.DEV) {
    await import('../mocks/browser').then(({ startWorker }) => startWorker());
}

const store = createAppStore({ authClient: createAuthClient() });

createRoot(document.getElementById('root') as HTMLElement).render(
    <Provider store={store}>
        <NotificationsContainer />
        <AuthNotificationListener />
        <RouterProvider router={router} />
    </Provider>
);
